import { render, staticRenderFns } from "./ModalUpdateAddress.vue?vue&type=template&id=34bf98b5&scoped=true&"
import script from "./ModalUpdateAddress.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateAddress.vue?vue&type=script&lang=js&"
import style0 from "./ModalUpdateAddress.vue?vue&type=style&index=0&id=34bf98b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bf98b5",
  null
  
)

export default component.exports